import { useContext, useEffect, useState } from "react";
import moment from "moment";
import Login from "../../pages/login";
import { User, UserSession } from "../../models/user";
import Main from "../../components/main/main";
import { LoginStore } from "../../stores/LoginStore";
import AuthContext from './authContext';
import { CookiesProvider, useCookies } from 'react-cookie';
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";

const loginStore = new LoginStore();
export const AuthManager = ({ Component, pageProps }: any) => {
        const [isLoading, setIsLoading] = useState(true);
        const authContext = useContext(AuthContext);
        const [cookie, setCookie] = useCookies();
        const router = useNavigate();    
        const location = useLocation();    
        const loggedOutPages = ['/changePassword'];
        useEffect(() => {    
            const checkToken = async () => {
                authContext.updateAccessToken(loginStore.accessToken);                
            
                if (!authContext.accessToken && !cookie._ath) {
                    const pageCheck = _.filter(loggedOutPages, page => {
                        return _.startsWith(location.pathname, page);
                      }).length > 0; 
                    if (pageCheck) {
                        router(location.pathname)
                        setIsLoading(false);
                        return;
                    }
                    router("/login")
                    setIsLoading(false);
                } else {
                    const userSession: UserSession = {
                        jwt: authContext.accessToken,
                        user: {} as User,
                        authenticated: true,
                        roles: [],
                        isFirstLogin: false,
                    };
                    authContext.updateUser(userSession);
                    const expiration = moment().add(2, 'hour').toDate();
                    if (!cookie._ath) setCookie('_ath', authContext.accessToken, {expires: expiration});
                    router("/")
                    setIsLoading(false);
                }
            }
            checkToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [authContext.accessToken]);

        return (
            <CookiesProvider>
                <Main 
                    isLoading={isLoading}
                    Component={(authContext.user && authContext.user.authenticated) 
                        || _.filter(loggedOutPages, page => {
                            return _.startsWith(location.pathname, page);
                          }).length > 0
                        ? Component 
                        : Login} 
                    user={authContext.user} 
                    loginStore={loginStore} 
                    pageProps={pageProps} 
                />
            </CookiesProvider>
        );
};